import PropTypes from 'prop-types';
import { BsBuilding, BsPerson } from 'react-icons/bs';

import FormField from '#globalComponents/Forms/FormField';

import RecipientSearchPicker from './RecipientSearchPicker';

/**
 * Chooses whose values fill a test send or preview: a real contact-list recipient, or sample data.
 */
const SampleRecipientField = ({
	recipient,
	onChange,
	listIds,
	disabled,
	label = 'Platzhalter füllen mit',
	className,
}) => {
	const RecipientIcon = recipient?.crmContactId ? BsPerson : BsBuilding;

	return (
		<FormField
			label={label}
			className={className}
			hint={
				recipient
					? `Es werden die echten Werte von ${recipient.name} verwendet – wie beim Versand.`
					: 'Ohne Auswahl werden Beispielwerte verwendet (z. B. Max Mustermann).'
			}
		>
			{recipient ? (
				<div className="flex items-center justify-between gap-3 rounded-control border border-bgBase-500 bg-white px-3 py-2 text-sm">
					<span className="flex items-center gap-2 min-w-0 text-text">
						<RecipientIcon className="w-3.5 h-3.5 shrink-0 text-bgBase-800" />
						<span className="truncate">{recipient.name}</span>
					</span>
					<button
						type="button"
						onClick={() => onChange(null)}
						disabled={disabled}
						className="shrink-0 text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors"
					>
						Beispielwerte verwenden
					</button>
				</div>
			) : (
				<RecipientSearchPicker onChange={onChange} listIds={listIds} />
			)}
		</FormField>
	);
};

SampleRecipientField.propTypes = {
	// { name, crmContactId } or { name, crmCompanyId }; null = sample data
	recipient: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	listIds: PropTypes.arrayOf(PropTypes.string),
	disabled: PropTypes.bool,
	label: PropTypes.node,
	className: PropTypes.string,
};

export default SampleRecipientField;
